import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "close-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: "assets/administrator/Close.svg",
          alt: "close",
          class: "icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        })
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "wrapper-details" }, [
        _createElementVNode("div", { class: "wrapper-file" }, [
          _createElementVNode("img", {
            src: "assets/corporate/Image1.png",
            alt: "preview",
            class: "file"
          })
        ])
      ], -1))
    ])
  ]))
}